export const UserRole = {
  INVESTOR: 'INVESTOR',
  INSTALLER: 'INSTALLER',
  ADMIN: 'ADMIN',
  EXTERNAL: 'EXTERNAL'
};